/**
 * 花瓣欠费模块日志工具
 * 独立配置，不影响 P云广告的日志
 */

// 花瓣模块独立的日志级别配置
// 'off': 关闭所有, 'error': 只输出错误, 'warn': 警告+错误, 'info': 全部, 'debug': 调试
const ARREARS_LOG_LEVEL = 'error' // 测试环境用 'info'，上线后改为 'error'

// 日志级别优先级
const LOG_LEVELS = {
  off: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4
}

// 获取当前配置的日志级别
const currentLevel = LOG_LEVELS[ARREARS_LOG_LEVEL] || LOG_LEVELS.error

/**
 * 日志工具
 * 只有当配置级别 >= 日志级别时才输出
 */
export const arrearsLogger = {
  info (...args) {
    if (currentLevel >= LOG_LEVELS.info) {
      console.log('[Arrears]', ...args)
    }
  },

  warn (...args) {
    if (currentLevel >= LOG_LEVELS.warn) {
      console.warn('[Arrears]', ...args)
    }
  },

  error (...args) {
    if (currentLevel >= LOG_LEVELS.error) {
      console.error('[Arrears]', ...args)
    }
  },

  debug (...args) {
    if (currentLevel >= LOG_LEVELS.debug) {
      console.log('[Arrears][DEBUG]', ...args)
    }
  }
}

export default arrearsLogger
